import React from 'react'
import {Link} from 'react-router-dom'
import {Menu, Icon} from 'antd'

const MainMenu = ({pathname}) => (
  <Menu defaultSelectedKeys={pathname} mode='inline'>
    <Menu.Item key='/home/customers-list'>
      <Link to='/home/customers-list'>
        <Icon type='idcard'/>
        <span>Customers list</span>
      </Link>
    </Menu.Item>
    <Menu.SubMenu
      key='sub1'
      title={<span><Icon type='usergroup-add'/><span>Invited users</span></span>}
    >
      <Menu.Item key='/home/send-invites'><Link to='/home/send-invites'>Send invites</Link></Menu.Item>
      <Menu.Item key='/home/received-invites'><Link to='/home/received-invites'>Received invites</Link></Menu.Item>
    </Menu.SubMenu>
    <Menu.Item key='logOut' onClick={() => {
      localStorage.clear()
      window.location.reload()
    }}>
      <Icon type="logout"/>
      <span>Log out</span>
    </Menu.Item>
  </Menu>
)

export default MainMenu
